import { CSSProperties } from 'react';

export const spaceStyle: CSSProperties = {
  justifyContent: 'center',
  alignItems: 'center',
};
